export const pieChartOption = () => {
    return {
        title: {
            text: '',
            left: 'center'
        },
        tooltip: {
            trigger: "item",
            formatter: (params) => {
                const { data } = params;
                const text = `${params.marker}${data.name}:${data.value}  ${params.percent}%`;
                return text;
            },
        },
        legend: {
            top: '5%',
            left: 'center'
        },
        series: [
            {
                type: 'pie',
                radius: '40%',
                labelLine: {
                    smooth: true
                },
                data: [
                    { value: 1048, name: 'Search Engine' },
                    { value: 735, name: 'Direct' },
                    { value: 580, name: 'Email' },
                    { value: 484, name: 'Union Ads' },
                    { value: 300, name: 'Video Ads' }
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                },
                label: {
                    normal: {
                        show: true,
                        formatter: '{b}:{c} {d}%',
                        fontSize: 14,
                        fontWeight: 'bold'
                    }
                }
            }
        ]
    }
};



